<template>
  <div ref="map" class="card-mapa-google"></div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/OverlappingMarkerSpiderfier/1.0.3/oms.min.js"></script>
<script>
import {
  createGoogleMapsMarker,
  withGoogleMapsMapId,
} from "@/utils/googleMapsMarkers";

export default {
  name: "CardMapaGoogle",

  props: {
    item: { type: Object, required: true },
  },

  computed: {
    coordenadas() {
      const latitude = this.toCoordinate(this.item?.latitude);
      const longitude = this.toCoordinate(this.item?.longitude);

      if (latitude === null || longitude === null) {
        return null;
      }

      return {
        lat: latitude,
        lng: longitude,
      };
    },
  },

  data() {
    return {
      map: {},
      markers: [],
      oms: {},
    };
  },

  methods: {
    toCoordinate(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const normalizedValue = typeof value === "string" ? value.trim() : value;

      if (normalizedValue === "") {
        return null;
      }

      const coordinate = Number(normalizedValue);
      return Number.isFinite(coordinate) ? coordinate : null;
    },
    initMap() {
      if (
        !this.coordenadas ||
        !this.$refs.map ||
        !window.google ||
        !window.google.maps
      ) {
        return;
      }

      const maps = window.google.maps;

      this.markers = [];
      this.map = new maps.Map(
        this.$refs.map,
        withGoogleMapsMapId({
          center: this.coordenadas,
          zoom: 7,
        })
      );

      this.oms = window.OverlappingMarkerSpiderfier
        ? new window.OverlappingMarkerSpiderfier(this.map, {
            markersWontMove: true,
            markersWontHide: true,
            basicFormatEvents: true,
          })
        : null;

      this.setMarker(this.coordenadas);
    },

    setMarker(Points, title = "Local") {
      //Criação do marker
      const maps = window.google.maps;
      var image = require("@/assets/perm_identity-24px-green.svg");

      const icon = {
        url: image,
        // This marker is 20 pixels wide by 32 pixels high.
        size: new maps.Size(32, 32),
        // The origin for this image is (0, 0).
        origin: new maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new maps.Point(0, 32),
      };

      const marker = createGoogleMapsMarker({
        position: Points,
        map: this.map,
        title: title,
        icon: icon,
      });

      if (this.oms) {
        this.oms.addMarker(marker);
      }

      this.markers.push(marker);
    },
  },

  mounted() {
    this.initMap();
  },

  watch: {
    coordenadas: function () {
      this.$nextTick(() => this.initMap());
    },
  },
};
</script>

<style scoped>
.card-mapa-google {
  height: 450px;
  width: 100%;
}
</style>
